var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineBasedGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 17.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 11H8.8a1.1 1.1 0 00-1.1 1.1v4.4a1.1 1.1 0 001.1 1.1h4.4a1.1 1.1 0 001.1-1.1v-4.4a1.1 1.1 0 00-1.1-1.1zM6.6 1.1A1.1 1.1 0 005.5 0H1.1A1.1 1.1 0 000 1.1v4.4a1.1 1.1 0 001.1 1.1h3.29L6.905 11A2.193 2.193 0 018.8 9.9h.01L6.6 6.033V4.4h7.7V2.2H6.6zM20.9 0h-4.4a1.1 1.1 0 00-1.1 1.1v4.4a1.1 1.1 0 001.1 1.1h4.4A1.1 1.1 0 0022 5.5V1.1A1.1 1.1 0 0020.9 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBasedGrid);
export default __webpack_public_path__ + "static/media/line-based-grid.bf82d2a0a2226035bde29cb8916b20e4.svg";
export { ForwardRef as ReactComponent };